import React from 'react'
import {
    Box,
    Flex,
    Icon,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

const ProductRegistrationBenefitCard = ({icon, title, description, datatestid}) => {
    const styles = useMultiStyleConfig('ProductRegistration')
    return (
        <Flex {...styles.benefitContainer} data-testid={datatestid}>
            <Box {...styles.benefitBox}>
                <Icon as={icon} {...styles.benefitIcon} />
                <Box {...styles.benefitDescriptionContainer}>
                    <Text {...styles.benefitTitle}>{title}</Text>
                    <Text {...styles.benefitDescription}>{description}</Text>
                </Box>
            </Box>
        </Flex>
    )
}

ProductRegistrationBenefitCard.propTypes = {
    icon: PropTypes.elementType,
    title: PropTypes.node,
    description: PropTypes.node,
    variant: PropTypes.string,
    datatestid: PropTypes.string,
}

export default ProductRegistrationBenefitCard
